import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NoticeBoardOne = () => {
  const [noticeboardData, setNoticeboardData] = useState([]);

  useEffect(() => {
    fetchNoticeboardData();
  }, []);

  const fetchNoticeboardData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-last3-noticeboard-data`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setNoticeboardData(response?.data?.data);
      // console.log(response);

      // console.log(response);
    } catch (error) {
      // console.log(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <div className="col-xxl-4">
      <div className="card h-100">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
            <h6 className="mb-2 fw-bold text-lg mb-0">Notice board</h6>
            <Link
              to="/noticeboard-list"
              className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
            >
              View All
              <Icon icon="solar:alt-arrow-right-linear" className="icon" />
            </Link>
          </div>

          {noticeboardData.length > 0 ? (
            noticeboardData.map((item, index) => (
              <div className="d-flex align-items-start gap-2 mb-20">
                <img
                  // src="assets/images/notice/board-img1.png"
                  src={
                    item?.noticeboardCategory_id?.icon ||
                    "assets/images/notice/board-img1.png"
                  }
                  alt=""
                  className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                />
                <div className="flex-grow-1">
                  <h6 className="text-md mb-1 fw-semibold">
                    {item?.role_id?.rolename}
                  </h6>
                  <p className="text-sm text-secondary-light fw-medium mb-1">
                    {item?.content || "No content available."}
                  </p>
                  <span className="text-sm text-secondary-light fw-normal">
                    {item?.createdAt ? formatDate(item.createdAt) : "N/A"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <>
              {/* <div className="d-flex align-items-start gap-2">
                <img
                  src="assets/images/notice/board-img3.png"
                  alt=""
                  className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                />
                <div className="flex-grow-1">
                  <h6 className="text-md mb-1 fw-semibold">New Course Start</h6>
                  <p className="text-sm text-secondary-light fw-medium mb-1">
                    Lorem Ipsum is simply dummy text of the printing Lorem Ipsum
                    is simply dummy text of the printing and typesetting
                    industry.
                  </p>
                  <span className="text-sm text-secondary-light fw-normal">
                    25 Jan 2024
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-start gap-2">
                <img
                  src="assets/images/notice/board-img3.png"
                  alt=""
                  className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                />
                <div className="flex-grow-1">
                  <h6 className="text-md mb-1 fw-semibold">New Course Start</h6>
                  <p className="text-sm text-secondary-light fw-medium mb-1">
                    Lorem Ipsum is simply dummy text of the printing Lorem Ipsum
                    is simply dummy text of the printing and typesetting
                    industry.
                  </p>
                  <span className="text-sm text-secondary-light fw-normal">
                    25 Jan 2024
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-start gap-2">
                <img
                  src="assets/images/notice/board-img3.png"
                  alt=""
                  className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                />
                <div className="flex-grow-1">
                  <h6 className="text-md mb-1 fw-semibold">New Course Start</h6>
                  <p className="text-sm text-secondary-light fw-medium mb-1">
                    Lorem Ipsum is simply dummy text of the printing Lorem Ipsum
                    is simply dummy text of the printing and typesetting
                    industry.
                  </p>
                  <span className="text-sm text-secondary-light fw-normal">
                    25 Jan 2024
                  </span>
                </div>
              </div> */}
              <p>No Notifications found</p>
            </>
          )}
          {/* <div className="d-flex align-items-start gap-2 mb-20">
                        <img
                            src="assets/images/notice/board-img2.png"
                            alt=""
                            className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                        />
                        <div className="flex-grow-1">
                            <h6 className="text-md mb-1 fw-semibold">Kathryn Murphy</h6>
                            <p className="text-sm text-secondary-light fw-medium mb-1">
                                Lorem Ipsum is simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry.
                            </p>
                            <span className="text-sm text-secondary-light fw-normal">
                                25 Jan 2024
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-start gap-2">
                        <img
                            src="assets/images/notice/board-img3.png"
                            alt=""
                            className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                        />
                        <div className="flex-grow-1">
                            <h6 className="text-md mb-1 fw-semibold">Cameron Williamson</h6>
                            <p className="text-sm text-secondary-light fw-medium mb-1">
                                Lorem Ipsum is simply dummy text of the printing Lorem Ipsum is
                                simply dummy text of the printing and typesetting industry.
                            </p>
                            <span className="text-sm text-secondary-light fw-normal">
                                25 Jan 2024
                            </span>
                        </div>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default NoticeBoardOne;
